import React, { FC } from 'react'
import Caret from '@mortgage-pos/ui/assets/Caret.svg'

export enum ButtonVariants {
  next,
  skip,
  back,
  signIn,
  default,
}

export type Props = {
  type?: 'button' | 'submit' | 'reset'
  variant?: ButtonVariants
  content?: string
  onClick?: (event: React.SyntheticEvent) => void
  pageIndex?: string | number
  className?: string
  rest?: object
  disabled?: boolean
}

const Button: FC<Props> = ({
  content,
  onClick,
  variant = null,
  pageIndex,
  className,
  type = 'button',
  disabled = false,
  ...rest
}) => {
  switch (variant) {
    case ButtonVariants.next:
      return (
        <button
          className={`button ${className ? className : ''}`}
          id={pageIndex ? `next-cta-${pageIndex}` : null}
          data-testid="next-cta"
          type={type}
          onClick={onClick}
          disabled={disabled}
          {...rest}
        >
          {content || 'Continue'}
        </button>
      )

    case ButtonVariants.skip:
      return (
        <button
          className={`button --skip ${className ? className : ''}`}
          data-testid="skip-button"
          type={type}
          onClick={onClick}
          disabled={disabled}
          {...rest}
        >
          {content || 'Skip'}
        </button>
      )

    case ButtonVariants.back:
      return (
        <button
          className={`button --back ${className ? className : ''}`}
          onClick={onClick}
          data-testid="back-button"
          type={type}
          disabled={disabled}
          {...rest}
        >
          <img className="button__caret" src={Caret} alt="caret-icon" />
          Go Back
        </button>
      )

    case ButtonVariants.signIn:
      return (
        <button
          className={`button --sign-in ${className ? className : ''}`}
          onClick={onClick}
          data-testid="sign-in-button"
          type={type}
          disabled={disabled}
          {...rest}
        >
          {content || 'Sign in'}
        </button>
      )

    default:
      return (
        <button
          data-testid="default-button"
          className={className}
          onClick={onClick}
          type={type}
          disabled={disabled}
          {...rest}
        >
          {content}
        </button>
      )
  }
}

export default Button
